import React, { useEffect, useState } from "react";
import moment from "moment";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import { FormPesaje } from "./FormPesaje/components/FormPesaje";
import { TrasladosApi } from "../../../api/TrasladosApi";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { RecepcionesSeleccionadas } from "./RecepcionesSeleccionadas";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { getUltimoPesaje } from "../helpers/pesajes";
import { PesajeTrasladoApi } from "../api/PesajeTrasladoApi";
import { DecisionSwal } from "../../../../../Utils/Utils/DecisionSwal";

export const ListadoMateriaPrima = ({
    configuraciones,
    user,
    trasladoId,
    regresar,
    navigateToBoleta,
    refrescarPesajeAutomatico,
    navigateToRecepciones,
}) => {
    const [trasladoDetalle, setTrasladoDetalle] = useState(null);
    const [materiaPrimaSeleccionada, setMateriaPrimaSeleccionada] =
        useState(null);

    const recepcionesSeleccionadas =
        trasladoDetalle && trasladoDetalle.detalles
            ? trasladoDetalle.detalles
            : [];

    const { getTrasladoDetalle, cargando: cargandoTraslado } = TrasladosApi();

    const {
        darSalidaTraslado,
        eliminarMateriaPrima,
        cargando: cargandoPesaje,
    } = PesajeTrasladoApi();

    const GetTrasladoDetalle = async () => {
        try {
            const data = await getTrasladoDetalle(trasladoId);

            setTrasladoDetalle(data);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar el detalle del traslado.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setTrasladoDetalle({});
        }
    };

    useEffect(() => {
        GetTrasladoDetalle();
    }, [trasladoId]);

    const onAsignacionPesoSuccess = () => {
        // regresar a la lista de recepciones seleccionadas para que se vea el cambio reflejado
        setMateriaPrimaSeleccionada(null);
        // refrescar el detalle del traslado para que se vea el cambio reflejado en el peso neto real
        GetTrasladoDetalle();
    };

    const DarSalidaTraslado = async (observaciones) => {
        // obtener último pesaje para saber el peso final del camión
        const ultimoPesaje = getUltimoPesaje(trasladoDetalle.pesajes);
        if (!ultimoPesaje || !ultimoPesaje.peso_final) {
            NotificationManager.error(
                "No se puede dar salida al traslado porque no hay un peso final registrado.",
                "Error",
                3000,
            );
            return;
        }

        try {
            await darSalidaTraslado({
                peso_bruto: ultimoPesaje.peso_final,
                observaciones: observaciones,
                traslado_id: trasladoId,
            });

            NotificationManager.success(
                "Traslado enviado a planta correctamente",
                "Éxito",
                3000,
            );

            navigateToBoleta(trasladoId);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al enviar el traslado a planta.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EliminarMateriaPrima = async (materiaPrimaId) => {
        try {
            if (!materiaPrimaId) {
                NotificationManager.error(
                    "No se pudo eliminar la materia prima del traslado porque no se encontró el ID de la materia prima.",
                    "Error",
                    3000,
                );
                return;
            }

            await eliminarMateriaPrima({
                materia_prima_id: materiaPrimaId,
                traslado_id: trasladoId,
            });

            NotificationManager.success(
                "Materia prima eliminada del traslado correctamente",
                "Éxito",
                3000,
            );

            GetTrasladoDetalle();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar la materia prima del traslado.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const MostrarMensajeEliminacionMateriaPrima = (materiaPrimaId) => {
        let mensaje = "¿Desea eliminar esta materia prima?";
        mensaje +=
            " Se perderán las recepciones seleccionadas de esta materia prima";

        DecisionSwal(mensaje, "Sí", "No", () =>
            EliminarMateriaPrima(materiaPrimaId),
        );
    };

    return (
        <div className="pesaje-traslado__tab-wrapper">
            <CardEmpty noShadow>
                {materiaPrimaSeleccionada ? (
                    <FormPesaje
                        regresar={() => setMateriaPrimaSeleccionada(null)}
                        materiaPrimaSeleccionada={materiaPrimaSeleccionada}
                        recepcionesSeleccionadas={recepcionesSeleccionadas}
                        configuraciones={configuraciones}
                        user={user}
                        trasladoDetalle={trasladoDetalle}
                        refrescarPesajeAutomatico={refrescarPesajeAutomatico}
                        onAsignacionPesoSuccess={onAsignacionPesoSuccess}
                    />
                ) : (
                    <LoadMask loading={cargandoTraslado || cargandoPesaje} blur>
                        <RecepcionesSeleccionadas
                            trasladoDetalle={trasladoDetalle}
                            recepcionesSeleccionadas={recepcionesSeleccionadas}
                            setMateriaPrimaSeleccionada={
                                setMateriaPrimaSeleccionada
                            }
                            regresar={regresar}
                            DarSalidaTraslado={DarSalidaTraslado}
                            MostrarMensajeEliminacionMateriaPrima={
                                MostrarMensajeEliminacionMateriaPrima
                            }
                            navigateToRecepciones={navigateToRecepciones}
                        />
                    </LoadMask>
                )}
            </CardEmpty>
        </div>
    );
};
